import React from "react";
import PageLayout from "../UI/PageLayout";
import { Tabs, Typography } from "antd";
import AdminUserManagemenTab from "../../containers/Settings/AdminUserManagemenTab";
import AdminCacheManagementTab from "../../containers/Settings/AdminCacheManagementTab";


const AdminSettingsPage = () => {
  return (
    <PageLayout
      title="Admin Settings"
      subTitle="Manage admin-level configuration and controls"
      content={
        <div>
            <Tabs
                items={[
                    {
                        key: "user-management",
                        label: "User Management",
                        children: <AdminUserManagemenTab />,
                    },
                    {
                      key: "cache-management",
                      label: "Manage Application Cache",
                      children: <AdminCacheManagementTab />,
                    }
                ]}
            />
        </div>
      }
    />
  );
};

export default AdminSettingsPage; 